import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

const API_URL = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_BACKEND_URL || '');

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: 'loading', message: '' });

  useEffect(() => {
    const e = params.get('e');
    const t = params.get('t');
    if (!e || !t) {
      setState({ status: 'error', message: 'Invalid unsubscribe link' });
      return;
    }
    axios.get(`${API_URL}/api/broadcasts/unsubscribe`, { params: { e, t } })
      .then(res => setState({ status: 'success', message: res.data.message, email: res.data.email }))
      .catch(err => setState({ status: 'error', message: err.response?.data?.detail || 'Unsubscribe failed' }));
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center space-y-4" data-testid="unsubscribe-card">
          {state.status === 'loading' && (
            <>
              <Loader2 className="w-12 h-12 mx-auto animate-spin text-primary" />
              <p>Processing…</p>
            </>
          )}
          {state.status === 'success' && (
            <>
              <CheckCircle2 className="w-12 h-12 mx-auto text-green-500" />
              <h1 className="text-xl font-bold">You're unsubscribed</h1>
              {state.email && <p className="text-sm text-muted-foreground" data-testid="unsubscribed-email"><code>{state.email}</code></p>}
              <p className="text-sm text-muted-foreground">{state.message}</p>
              <Link to="/"><Button variant="ghost" data-testid="unsubscribe-home-btn">Back to NextGig</Button></Link>
            </>
          )}
          {state.status === 'error' && (
            <>
              <XCircle className="w-12 h-12 mx-auto text-red-500" />
              <h1 className="text-xl font-bold">Unsubscribe failed</h1>
              <p className="text-sm text-muted-foreground" data-testid="unsubscribe-error">{state.message}</p>
              <Link to="/"><Button variant="ghost">Back to NextGig</Button></Link>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
